<template>

  <div
      class="gj-card"
      :class="{'active':active,'tab-card':tabCard,'tab-card-active':tabCard&&active,'gj-card-border':border}"
      :style="{'width':width,'height':height,'padding':padding}"
      @click="$emit('click')">

    <div class="flex">
      <div class="gj-card-icon flex justify-center align-center" v-if="$slots.icon">
        <slot name="icon"></slot>
      </div>
      <div class="flex" style="flex: 1;">

        <div style="flex: 1;">
          <div class="gj-card-title" v-if="title">
            {{ title }}
            <slot name="title"></slot>
          </div>
          <div class="gj-card-number flex" style="align-items: baseline" :class="setFontClass()" v-if="isMeaningful(number)">
            <!--            传入数值为 number 或 string-->
            <template v-if="typeof number === 'number'||typeof number ==='string'">
              <!--                  需要自定义tooltip的-->
              <gj-tooltip v-if="hasTip">
                <template #content>
                  <slot name="hasTip"></slot>
                </template>
                <span :style="{'color': numberColor,'font-size':numberSize}">{{ number+suffix }}</span>
              </gj-tooltip>
              <!--              默认直接展示普通数值-->
              <span v-else :style="{'color': numberColor,'font-size':numberSize}">{{ number+suffix | defaultShow }}</span>
              <!--              若传入了对比值，且对比值与值不相等-->

              <slot name="compare">
                <div :style="{'font-size':compareSize,'line-height':compareSize}"
                     :class="{'colorRed':compareNumber<0,'colorGreen':compareNumber>0}"
                     style="margin-left: 4px;font-weight: normal;"
                     v-if="!isNaN(compareNumber)&&isMeaningful(compareNumber)&&compareNumber!=0">
                  <template v-if="compareNumber>0">+</template>
                  <span>{{ compareNumber+suffix }}</span>
                </div>
              </slot>

            </template>

            <!--            传入数值为 object-->
            <template v-if="typeof number === 'object'">
              <gj-tooltip>
                <template #content>
                  <!--                  需要自定义tooltip的-->
                  <slot v-if="hasTip" name="hasTip"></slot>
                  <!--                  默认只有进行过中文单位处理的数值，才用tooltip-->
                  <slot v-else name="tip">{{ number.origin }}</slot>
                </template>
                <span :style="{'color': numberColor,'font-size':numberSize}">{{ number.value }}</span>
                <span class="unit">{{ number.unit }}</span>
              </gj-tooltip>
              <!--              若传入了对比值，且对比值与值不相等-->

              <slot name="compare">
                <div :style="{'font-size':compareSize,'line-height':compareSize}"
                     :class="{'colorRed':compareNumber.originNum<0,'colorGreen':compareNumber.originNum>0}"
                     style="margin-left: 4px;font-weight: normal;"
                     v-if="compareNumber&&compareNumber.originNum!==0">
                  <template v-if="compareNumber.originNum>0">+</template>
                  <span>{{ compareNumber.value }}</span>
                  <span class="unit">{{ compareNumber.unit }}</span>
                </div>
              </slot>

            </template>


          </div>
        </div>

        <div style="flex: 1;" class="title-box2" v-if="title2">
          <div class="gj-card-title" v-if="title2">
            {{ title2 }}
            <slot name="title"></slot>
          </div>
          <div class="gj-card-number" :class="setFontClass()" v-if="number2">
            <span v-if="typeof number2 === 'number'||typeof number2 ==='string'">{{ number2 }}</span>
            <gj-tooltip
                :content="number2.origin"
                v-if="typeof number2 === 'object'"
            >
              <span>{{ number2.value }}</span>
              <span class="unit">{{ number2.unit }}</span>
            </gj-tooltip>
          </div>
        </div>

      </div>
    </div>

    <div class="gj-card-info" v-if="$slots.info">
      <slot name="info"></slot>
    </div>

    <slot class="content"></slot>

  </div>
</template>

<script>
import {amountSymbol} from "@/filters";
import {isMeaningful, isMeaningless} from "@/utils/common";
export default {
  name: "gj-card",
  props: {
    tabCard: {type: Boolean, default: false},
    // 是否有边框
    border: {type: Boolean, default: true},
    // card标题
    title: {},
    title2: {},
    suffix: {type: String, default: ''},
    // card数值，必须为number、string、object类型
    number: {},
    // 数字颜色
    numberColor: null,
    // 数字对比大小
    numberSize: {type: String, default: '22px'},
    // gj-card-number 框中的数字和对比值，是否纵向排列
    isNumberColumn: {type: Boolean, default: false},
    //对比值 字体大小
    compareSize: {type: String, default: '12px'},
    // 普通数值是否有tooptip
    hasTip: {type: Boolean, default: false},
    number2: {},
    // 鼠标悬浮 默认 手
    cursor: {type: String, default: 'pointer'},
    // 聚焦
    active: {type: Boolean, default: false},
    // width
    width: {type: String, default: 'auto'},
    // height
    height: {type: String, default: 'auto'},
    // padding
    padding: {type: String, default: '19px 16px'},
    // 是否有对比
    compareNumber: null
  },
  methods: {
    isMeaningful,
    amountSymbol,
    setFontClass() {
      return {
        'gj-card-number-22': this.clientWidth >= 1920,
        'gj-card-number-20': this.clientWidth < 1920 && this.clientWidth >= 1440,
        'gj-card-number-18': this.clientWidth < 1440 && this.clientWidth >= 1366,
        'number-column':this.isNumberColumn
      }
    }
  }
}
</script>

<style scoped lang="scss">
.gj-card {
  position: relative;
  box-sizing: border-box;
  //padding: 19px 16px;
  display: inline-block;
  margin-right: -1px;

  .gj-card-icon {
    width: 44px;
    height: 44px;
    padding: 5px 0;
    margin-right: 16px;
  }

  .gj-card-title {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    height: 22px;
    font-weight: 400;
  }

  .gj-card-number {
    font-family: DINAlternate-Bold;
    color: #333333;
    line-height: 32px;
    font-weight: 700;

    .unit {
      font-weight: normal;
      font-size: 13px;
    }
  }

  .gj-card-number-22 {
    font-size: 22px;
  }

  .gj-card-number-20 {
    font-size: 20px;
  }

  .gj-card-number-18 {
    font-size: 18px;
  }

  .number-column{
    flex-direction: column;
  }

  .gj-card-info {
    margin-top: 5px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    color: #999;
  }

  //&:hover {
  //  z-index: 9;
  //  border: 1px solid #1F6EEF !important;
  //}
}

.gj-card-border{
  border: 1px solid #D8DADD;
}

.active {
  z-index: 9;
  border: 1px solid #1F6EEF !important;
}

.tab-card {
  //padding-top: 22px!important;
  cursor: pointer;

  &:hover {
    border-color: #D8DADD !important;
    //border-top: 3px solid #1F6EEF !important;
    &::before {
      z-index: 99;
      content: '';
      height: 3px;
      position: absolute;
      background-color: #1F6EEF;
      top: -1px;
      left: -1px;
      right: -1px;
    }
  }
}

.tab-card-active {
  border-color: #D8DADD !important;
  //border-top:3px solid #1F6EEF!important;
  &::before {
    content: '';
    height: 3px;
    position: absolute;
    background-color: #1F6EEF;
    top: -1px;
    left: -1px;
    right: -1px;
  }
}
</style>